@if (data?.miniCartSettings) {
    <div [class]="classes?.miniCartStyle">
        <div class="mini-cart-header">
            <span class="mini-cart-title">{{ "mini_cart_title" | translate }}</span>
            <button class="mini-cart-close" type="button">×</button>
        </div>
        <div class="mini-cart-items">
            @for (item of items; track item) {
                <div class="mini-cart-item">
                    <div class="mini-cart-item-photo">
                        <img [src]="item.images?.[0]?.url" [alt]="item.name" />
                    </div>
                    <div class="mini-cart-item-body">
                        <div class="mini-cart-item-title">{{ item.name }}</div>
                        @if (item.sections?.[0]?.parameters?.[0]; as param) {
                            <div class="mini-cart-item-property">
                                {{ param.value }}
                            </div>
                        }
                        <div class="mini-cart-item-controls">
                            <div class="mini-cart-counter">
                                <button type="button">−</button>
                                <span class="mini-cart-counter-value">{{ item.quantity || 1 }}</span>
                                <button type="button">+</button>
                            </div>
                            <div class="mini-cart-prices">
                                <span class="mini-cart-price">
                                    {{ getItemTotal(item) | number: "1.2-2" }} {{ currency }}
                                </span>
                                @if (item.oldPrice) {
                                    <span class="mini-cart-old-price">
                                        {{ +item.oldPrice | number: "1.2-2" }} {{ currency }}
                                    </span>
                                }
                            </div>
                        </div>
                    </div>
                    <button class="mini-cart-remove" type="button">×</button>
                </div>
            }
        </div>
        <div class="mini-cart-footer">
            <div class="mini-cart-total">
                <span class="mini-cart-total-label">{{ "shop_cart_total_price" | translate }}:</span>
                <span class="mini-cart-total-value"> {{ getTotalPrice() | number: "1.2-2" }} {{ currency }} </span>
            </div>
            @if (buttonSettings) {
                <div [class]="classes?.miniCartButtonWrapper">
                    <a [class]="getButtonStyles()">
                        @if (buttonSettings.buttonIcon?.isActive) {
                            <span class="icon" [innerHTML]="getIcon(buttonSettings.buttonIcon?.icon)"></span>
                        }
                        {{ buttonSettings.label | translate }}
                    </a>
                </div>
            }
        </div>
    </div>
}
